(function(){
  const root=document.documentElement;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  let ticking=false;
  const hero=document.querySelector('.achord-hero');
  const obj=document.querySelector('[data-object]');
  const progress=document.querySelector('[data-progress]');
  const header=document.querySelector('[data-header]');
  const archive=document.querySelector('.archive-track');
  const drop=document.querySelector('.drop-scene');
  const garment=document.querySelector('.garment');
  const feature=document.querySelector('[data-feature]');
  const poseScene=document.querySelector('[data-pose-film]');
  const poseVideo=document.querySelector('[data-pose-video]');
  const poseProgress=document.querySelector('[data-pose-progress]');
  const poseNumber=document.querySelector('[data-pose-number]');
  const poseCaption=document.querySelector('[data-pose-caption]');
  const themeButtons=document.querySelectorAll('[data-theme-toggle]');
  const themeLabels=document.querySelectorAll('[data-theme-label]');
  const themes=['obsidian','bone','chrome'];
  const themeNames={obsidian:'Obsidian',bone:'Bone',chrome:'Chrome'};
  let currentTheme='obsidian';
  try{currentTheme=localStorage.getItem('achord-theme')||'obsidian'}catch(e){}
  if(!themes.includes(currentTheme))currentTheme='obsidian';
  document.body.dataset.theme=currentTheme;
  function setTheme(theme){
    currentTheme=themes.includes(theme)?theme:'obsidian';
    document.body.dataset.theme=currentTheme;
    themeLabels.forEach(x=>x.textContent=themeNames[currentTheme]);
    try{localStorage.setItem('achord-theme',currentTheme)}catch(e){}
  }
  setTheme(currentTheme);
  themeButtons.forEach(btn=>btn.addEventListener('click',()=>{
    const next=themes[(themes.indexOf(currentTheme)+1)%themes.length];
    setTheme(next);
  }));

  const poseCaptions=['Scroll to move through the campaign.','SILHOUETTE / The first impression.','STRUCTURE / Hold the frame.','ATTITUDE / Change the frequency.','ACHORD / Wear what’s next.'];
  function updatePose(){
    if(!poseScene||!poseVideo||reduced)return;
    const r=poseScene.getBoundingClientRect();
    const total=Math.max(poseScene.offsetHeight-window.innerHeight,1);
    const p=clamp(-r.top/total,0,1);
    if(poseVideo.readyState>=1 && isFinite(poseVideo.duration) && poseVideo.duration>0){
      const target=p*poseVideo.duration;
      if(Math.abs(poseVideo.currentTime-target)>0.035)poseVideo.currentTime=target;
    }
    if(poseProgress)poseProgress.style.height=(p*100)+'%';
    const idx=Math.min(4,Math.floor(p*5));
    if(poseNumber)poseNumber.textContent=String(idx+1).padStart(2,'0');
    if(poseCaption)poseCaption.textContent=poseCaptions[idx];
    poseScene.classList.toggle('is-ended',p>.985);
  }
  if(poseVideo){poseVideo.pause();poseVideo.addEventListener('loadedmetadata',updatePose)}

  function onScroll(){
    if(ticking)return; ticking=true;
    requestAnimationFrame(()=>{
      const y=window.scrollY;
      if(hero&&obj&&!reduced){
        const start=hero.offsetTop, end=start+hero.offsetHeight-window.innerHeight;
        const p=clamp((y-start)/Math.max(end-start,1),0,1);
        obj.style.transform=`translateX(-50%) translateY(${p*28}vh) scale(${1-p*.28}) rotate(${p*8}deg)`; const hv=hero.querySelector('.hero-video'); if(hv) hv.style.transform=`scale(${1.04+p*.08}) translateY(${p*-2}%)`;
        if(progress)progress.style.height=(p*100)+'px';
      }
      if(header)header.style.transform=y>70?'translateY(-3px)':'translateY(0)';
      if(drop&&garment&&!reduced){
        const r=drop.getBoundingClientRect(), p=clamp((window.innerHeight-r.top)/(drop.offsetHeight-window.innerHeight),0,1);
        garment.style.transform=`rotateY(${(-18+p*48)}deg) rotateX(${8-p*16}deg) translateY(${Math.sin(p*Math.PI)*-45}px) scale(${1+p*.08})`;
        if(feature){const labels=['01 / SILHOUETTE','02 / DETAIL','03 / FORM','04 / FREQUENCY'];feature.textContent=labels[Math.min(3,Math.floor(p*4))]}
      }
      updatePose();
      if(archive&&!reduced){const r=archive.parentElement.getBoundingClientRect();const p=clamp((window.innerHeight-r.top)/(r.height+window.innerHeight),0,1);archive.style.transform=`translateX(${-p*(archive.scrollWidth-window.innerWidth+window.innerWidth*.14)}px)`}
      ticking=false;
    });
  }
  window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll);onScroll();

  const menu=document.querySelector('[data-menu]'), mobile=document.querySelector('[data-mobile-menu]');
  if(menu)menu.addEventListener('click',()=>mobile&&mobile.classList.toggle('open'));
  document.querySelectorAll('.magnetic').forEach(el=>{if(reduced)return;el.addEventListener('mousemove',e=>{const r=el.getBoundingClientRect();const x=(e.clientX-r.left-r.width/2)*.12,y=(e.clientY-r.top-r.height/2)*.12;el.style.transform=`translate(${x}px,${y}px)`});el.addEventListener('mouseleave',()=>el.style.transform='')});
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-visible')}),{threshold:.12});
  document.querySelectorAll('[data-reveal],.product-card').forEach(x=>observer.observe(x));
})();
